import React from 'react';
import { LinkV2 } from '../LinkV2';

import {
  CardWrapper,
  Dek,
  Hed,
  LinkWrapper,
  Prehed,
  StyledImage,
} from './PreAuthCarouselCard.styles';

export type PreAuthCarouselCardProps = {
  image: string;
  altText: string;
  hed: string;
  dek?: string;
  prehed?: string;
  link?: {
    href: string;
    linkText?: string;
  };
  ariaLabel?: string;
};

const PreAuthCarouselCard: React.FC<PreAuthCarouselCardProps> = (props) => {
  const { image, prehed, hed, dek, altText, link, ariaLabel = 'advice' } = props;

  const { href, linkText } = link || {};
  return (
    <CardWrapper role="group" aria-label={ariaLabel}>
      {href ? (
        <LinkV2 href={href}>
          <StyledImage src={image} alt={altText} loading="lazy" />
        </LinkV2>
      ) : (
        <StyledImage src={image} alt={altText} loading="lazy" />
      )}
      {prehed && <Prehed>{prehed}</Prehed>}
      {hed &&
        (href ? (
          <LinkV2 href={href} noUnderline>
            <Hed>{hed}</Hed>
          </LinkV2>
        ) : (
          <Hed>{hed}</Hed>
        ))}
      {dek && <Dek>{dek}</Dek>}
      {href && linkText && (
        <LinkWrapper>
          <LinkV2 arrow href={href}>
            {linkText}
          </LinkV2>
        </LinkWrapper>
      )}
    </CardWrapper>
  );
};

export default PreAuthCarouselCard;
